module.exports = __webpack_public_path__ + "static/media/upgrade_drone_icon.046540a6.svg";